import {
    FETCH_HISTORICAL_DEVICE_LIST,
    FETCH_HISTORICAL_DEVICE_LIST_FETCHING,
    FETCH_HISTORICAL_DEVICE_LIST_SUCCESS,
    FETCH_HISTORICAL_DEVICE_LIST_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    historicalDeviceList: null,
    isFetching: false,
    success: false,
    error: false
};

const fetchHistoricalDeviceListFetching = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const fetchHistoricalDeviceListSuccess = (state, action) => {
    return {
        historicalDeviceList: action.historicalDeviceList,
        isFetching: false,
        success: true,
        error: false
    };
};

const fetchHistoricalDeviceListFail = (state) => {
    return {
        ...state,
        isFetching: false,
        error: true,
        success: false
    };
};

const handlers = {
    [FETCH_HISTORICAL_DEVICE_LIST_FETCHING]: fetchHistoricalDeviceListFetching,
    [FETCH_HISTORICAL_DEVICE_LIST_SUCCESS]: fetchHistoricalDeviceListSuccess,
    [FETCH_HISTORICAL_DEVICE_LIST_FAIL]: fetchHistoricalDeviceListFail
};

export default function historicalDeviceList(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchHistoricalDeviceList(evictCache) {
    return {
        type: FETCH_HISTORICAL_DEVICE_LIST,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export const getHistoricalDeviceList = (state) => {
    return state.historicalDeviceList && state.historicalDeviceList.historicalDeviceList
        ? state.historicalDeviceList.historicalDeviceList
        : null;
};

export const isHistoricalDeviceListFetching = (state) => {
    return state.historicalDeviceList.isFetching;
};

export const isHistoricalDeviceListSuccess = (state) => {
    return state.historicalDeviceList.success;
};
